import { createContext } from 'react'

export type CompositionContextType = string | null

export const CompositionContext = createContext<CompositionContextType>(null)
